import Reveal from "@/components/base/Reveal";

const FEATURES = [
  {
    icon: "ri-shield-check-line",
    title: "Verified hosts and cars",
    text: "Every host and vehicle is checked before it goes live, so you know exactly what you're getting.",
    accent: true,
  },
  {
    icon: "ri-secure-payment-line",
    title: "Pay the Kenyan way",
    text: "Checkout with M-Pesa in seconds. Your payment is protected until your trip is confirmed.",
  },
  {
    icon: "ri-refund-2-line",
    title: "Free cancellation",
    text: "Plans change. Cancel up to 24 hours before pick-up and get a full refund, no questions asked.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/7 local support",
    text: "Real people in Nairobi on call around the clock, from booking to breakdown.",
  },
];

export default function TrustSection() {
  return (
    <div className="border-y border-background-200/60 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-8 md:py-24">
        <Reveal className="max-w-2xl">
          <span className="text-sm font-medium uppercase tracking-[0.2em] text-primary-500">Why Gari</span>
          <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
            Built for trust on Kenyan roads
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((feature, index) => (
            <Reveal key={feature.title} delay={index * 100}>
              <div className="h-full rounded-2xl border border-background-200/70 bg-background-50 p-6">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${
                    feature.accent
                      ? "bg-primary-500 text-background-50"
                      : "bg-secondary-100/70 text-secondary-300"
                  }`}
                >
                  <i className={feature.icon}></i>
                </span>
                <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950">{feature.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}